import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ToastState {
  message: string;
  leaving: boolean;
}

@Injectable({ providedIn: 'root' })
export class ResponseToastService {
  private readonly state = new BehaviorSubject<ToastState | null>(null);
  readonly toast$ = this.state.asObservable();

  private timers: ReturnType<typeof setTimeout>[] = [];

  show(message: string): void {
    this.clearTimers();
    this.state.next({ message, leaving: false });
    this.timers.push(setTimeout(() => this.state.next({ message, leaving: true }), 2600));
    this.timers.push(setTimeout(() => this.state.next(null), 3000));
  }

  private clearTimers(): void {
    this.timers.forEach(clearTimeout);
    this.timers = [];
  }
}
